import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import './Oil.css';
import './Mobile.css';

import oil1 from './oil/oil1.jpg';

class Oil extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="app-container">
        <div className="header-container">
          <div className="header-left">
            <Link to="/">
              <div className="header-left-name">Sarah Mosley</div>
            </Link>
          </div>
          <div className="header-right">
            <div className="header-right-flex">
              <div className="header-right-link">Design</div>
              <Link to="/collage">
                <div className="header-right-link">Collage</div>
              </Link>
              <Link to="/oil">
                <div className="header-right-link header-active-link">Oil</div>
              </Link>
              <div className="header-right-link">Editorial</div>
              <Link to="/contact">
                <div className="header-right-link">Contact</div>
              </Link>
            </div>
          </div>
        </div>
        <div className="oil-container">
          <div className="oil-section oil-section-1">
            <img src={oil1} className="oil-image" />
            <div className="oil-title"><i>Pink from Renoir's "Pink and Blue"</i></div>
          </div>
        </div>
      </div>
    );
  }

}

export default Oil;
